<template>
  <div>
    <users-table></users-table>
  </div>
</template>

<script>
import UsersTable from "@/components/Team/UsersTable";
export default {
    components: {
        UsersTable
    }
};
</script>